import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { AccountService } from './account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class TipoEquipamentoService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
        this.url = '';
        this.url = SCAMP_API.accountApiV1;
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/tiposequipamentos`, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/tiposequipamentos/${id}`, { headers: this.account.composeHeaders() });
    }
    isUnique(descricao) {
        return this.http.post(`${SCAMP_API.accountApiV1}/tiposequipamentos/descricao/isunique`, { descricao }, { headers: this.account.composeHeaders() });
    }
    post(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/tiposequipamentos`, data, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/tiposequipamentos/${id}`, { headers: this.account.composeHeaders() });
    }
}
TipoEquipamentoService.ngInjectableDef = i0.defineInjectable({ factory: function TipoEquipamentoService_Factory() { return new TipoEquipamentoService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: TipoEquipamentoService, providedIn: "root" });
